import { render, staticRenderFns } from "./resultReport.vue?vue&type=template&id=60ca2454&scoped=true"
import script from "./resultReport.vue?vue&type=script&lang=js"
export * from "./resultReport.vue?vue&type=script&lang=js"
import style0 from "./resultReport.vue?vue&type=style&index=0&id=60ca2454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca2454",
  null
  
)

export default component.exports